import "reflect-metadata";
import { injectable, inject } from "inversify";
import { DIMixins } from "@/core/@types/types";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import { IF360FeatureFlagValidator } from "./F360FeatureFlagValidator";

@injectable()
export default class FeatureFlagValidator implements IF360FeatureFlagValidator {
  @inject(DIMixins.USER_PROFILE_STORAGE)
  userProfileMixin!: IUserProfileStorageMixin;

  handleValidationByName(name: string): boolean {
    try {
      const features = this.userProfileMixin.handleGetUserProfile()?.Features;

      if (!Array.isArray(features)) {
        return false;
      }

      return features.includes(name);
    } catch {
      return false;
    }
  }
}
